export default "__VITE_ASSET__DCCbdUfz__"